import { atom } from 'recoil';

export const appPermission = atom({
    key: 'appPermission',
    default: null,

});

export const environmentList = atom({
    key: 'environmentList',
    default: null,

});

export const currentEnvironment = atom({
    key: 'currentEnvironment',
    default: null,
});

export const userGroupsCode = atom({
    key:'userValidGroup',
    default: null,
})

export const ApplicationListData = atom({
    key:'USER_APP_LIST',
    default: []
})